<div class="table-scroll-container">
  <table mat-table [dataSource]="isLoading() ? loadingPlaceholderRows() : mappedDataSource" id="my-table" matSort (matSortChange)="onSortChanged($event)">
    <ng-container matColumnDef="itemId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dataManagement.import.id' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '40%'">{{ element.itemId }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="version">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dataManagement.import.version' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '30%'">{{ element.version }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="exportingOrganization">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'dataManagement.import.exportingOrganization' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '80%'">{{ element.exportingOrganization.name }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="packagingTypeName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'packagingUnit.packagingUnitType' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">{{ element.packagingTypeName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="brandName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'packagingUnit.fields.brandName' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">{{ element.brandName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="productName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'packagingUnit.fields.productName' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '80%'">{{ element.productName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="packagingComponentCategoryName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'component.componentType' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">{{ element.packagingComponentCategoryName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="packagingComponentSubtypeName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'component.componentSpecificType' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">{{ element.packagingComponentSubtypeName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="articleName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'component.fields.articleName' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '80%'">{{ element.articleName }}</ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="articleNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'component.fields.articleNumber' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '50%'">{{ element.articleNumber }}</ng-container>
      </td>
    </ng-container>

    <ng-container *ngIf="!this.isChange" matColumnDef="timestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'component.fields.exportTimestamp' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '70%'">{{ element.exportTimestamp | date: 'short' }}</ng-container>
      </td>
    </ng-container>

    <ng-container *ngIf="this.isChange" matColumnDef="timestamp">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'component.fields.lastModificationTimestamp' | transloco }}
      </th>
      <td mat-cell *matCellDef="let element">{{ element.lastModificationTimestamp | date: 'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        <span class="header-text">{{ 'dataManagement.actions' | transloco }}</span>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '48px'; height: '24px'">
          <button
            mat-icon-button
            type="button"
            (click)="navigateToCandidate(element)"
            matTooltip="{{
              (isPackagingSystem
                ? 'packagingSystem.viewPackagingSystem'
                : isPackagingUnit
                  ? 'packagingUnit.viewPackagingUnit'
                  : isComponent
                    ? 'component.viewComponent'
                    : isMaterial
                      ? 'material.viewMaterial'
                      : ''
              ) | transloco
            }}"
            *ngIf="!isChange; else viewChanges">
            <mat-icon>preview</mat-icon>
          </button>
          <ng-template #viewChanges>
            <button
              mat-icon-button
              type="button"
              (click)="navigateToCandidate(element, true)"
              matTooltip="{{
                (isPackagingSystem
                  ? 'packagingSystem.viewPackagingSystemBeforeChange'
                  : isPackagingUnit
                    ? 'packagingUnit.viewPackagingUnitBeforeChange'
                    : isComponent
                      ? 'component.viewComponentBeforeChange'
                      : isMaterial
                        ? 'material.viewMaterialBeforeChange'
                        : ''
                ) | transloco
              }}">
              <mat-icon>access_time</mat-icon>
            </button>
            <button
              mat-icon-button
              type="button"
              (click)="navigateToCandidate(element, false)"
              matTooltip="{{
                (isPackagingSystem
                  ? 'packagingSystem.viewPackagingSystemAfterChange'
                  : isPackagingUnit
                    ? 'packagingUnit.viewPackagingUnitAfterChange'
                    : isComponent
                      ? 'component.viewComponentAfterChange'
                      : isMaterial
                        ? 'material.viewMaterialAfterChange'
                        : ''
                ) | transloco
              }}">
              <mat-icon>access_time_filled</mat-icon>
            </button>
          </ng-template>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <div (click)="$event.stopPropagation()">
          <button mat-button class="filter-button" (click)="selectAll()" type="button">
            <div>
              {{ ((isChange ? isAllCandidatesSelected : isAllCandidateIdsSelected) ? 'common.buttons.selectNone' : 'common.buttons.selectAll') | transloco }} <br />
              ({{ isChange ? selectedCandidates.length : selectedCandidateIds.size }} {{ 'common.text.selected' | transloco }})
            </div>
          </button>
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *appSingleBlocSkeleton="isLoading(); width: '24px'; height: '24px'">
          <mat-checkbox [checked]="isSelectedCandidate(element)" (change)="setSelectedCandidates($event.checked, element)" class="margin-checkbox"> </mat-checkbox>
        </ng-container>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.notificationBackground]="row.hasNotification"></tr>
  </table>
</div>
<mat-paginator
  class="import-html-paginator"
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="currentPageSize()"
  [length]="totalItemCount"
  [pageIndex]="currentPageIndex"
  showFirstLastButtons
  aria-label="Select page"
  (page)="onPageChanged($event)" />
